(function () {
  "use strict";
  if (!customElements.get("columns-slider")) {
    customElements.define(
      "columns-slider",
      class extends HTMLElement {
        constructor() {
          super();
          this.flkty = null;
          this.gutter = 0;
          this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
        }

        connectedCallback() {
          this.checkSlidesSize();
          document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize);
        }

        initSlider() {
          this.classList.remove("carousel--inactive");
          this.flkty = new window.theme.Flickity(this, {
            pageDots: true,
            cellAlign: "left",
            groupCells: true,
            contain: true,
            on: {
              ready: () => {
                this.setSliderArrowsPosition(this);
                setTimeout(() => {
                  this.changeTabIndex();
                  this.flkty.resize();
                }, 0);
              },
              change: () => {
                this.changeTabIndex();
              },
            },
          });
          this.createResizeClass();
        }

        createResizeClass() {
          if (typeof window.theme.Flickity.prototype._createResizeClass === "function") return;
          window.theme.Flickity.prototype._createResizeClass = function () {
            this.element.classList.add("carousel--resize");
          };
          window.theme.Flickity.createMethods.push("_createResizeClass");
          const originalResize = window.theme.Flickity.prototype.resize;
          window.theme.Flickity.prototype.resize = function () {
            this.element.classList.remove("carousel--resize");
            originalResize.call(this);
            this.element.classList.add("carousel--resize");
          };
        }

        destroySlider() {
          this.classList.add("carousel--inactive");
          if (this.flkty !== null) {
            this.flkty.destroy();
            this.flkty = null;
          }
        }

        checkSlidesSize() {
          const item = this.querySelector("[data-slider-item]");
          if (!item) return;

          const style = item.currentStyle || window.getComputedStyle(item);
          this.gutter = parseInt(style.marginRight, 10) || 0;

          const canScroll = this.offsetWidth < this.getItemsWidth();

          // Allow initialization on mobile as well
          if (canScroll) {
            if (!this.flkty) this.initSlider();
          } else {
            this.destroySlider();
          }
        }

        changeTabIndex() {
          if (!this.flkty) return;
          const selectedIndex = this.flkty.selectedIndex;
          this.flkty.slides.forEach((slide, index) => {
            slide.cells.forEach((cell) => {
              cell.element.querySelectorAll("a, button").forEach((el) => {
                el.setAttribute("tabindex", selectedIndex === index ? "0" : "-1");
              });
            });
          });
        }

        getItemsWidth() {
          let width = 0;
          const items = this.querySelectorAll("[data-slider-item]");
          if (items.length) {
            items.forEach((item) => {
              width += item.offsetWidth + this.gutter;
            });
          }
          return width;
        }

        setSliderArrowsPosition(element) {
          const buttons = element.querySelectorAll(".flickity-button");
          const containers = element.querySelectorAll("[data-media-container]");
          let maxContainerHeight = 0;

          containers.forEach((container) => {
            if (container.offsetHeight > maxContainerHeight) {
              maxContainerHeight = container.offsetHeight;
            }
          });

          if (buttons.length && maxContainerHeight > 0) {
            buttons.forEach((btn) => {
              btn.style.top = `${maxContainerHeight / 2}px`;
            });
          }
        }

        disconnectedCallback() {
          document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize);
        }
      }
    );
  }
})();
